import React from 'react'
import { SGFeaturedLink } from '@scentregroup/shared/types/featured-link'
import {
  CloudinaryImage,
  IMAGE_SIZES_HERO_PORTRAIT,
} from '../../hub-components/cloudinary-image'
import { Text } from '@hub/text'
import { H3 } from '@hub/heading'
import { Grid } from '@hub/grid'
import { LinkBox, LinkOverlay } from '@hub/link'

const SQUARE_THRESHOLD = 4

interface FeaturedLinksGridTrackers {
  clicked?: (label: string) => void
}

export const FeaturedLinksGrid: React.FC<
  React.PropsWithChildren<{
    featuredLinks: Array<SGFeaturedLink>
    itemsPerRow: number
    title: string
    square?: boolean
    trackers?: FeaturedLinksGridTrackers
  }>
> = ({
  featuredLinks,
  itemsPerRow,
  title,
  square = itemsPerRow >= SQUARE_THRESHOLD,
  trackers,
}) => {
  const imageType = square ? 'SQUARE' : 'WIDE'
  return (
    <>
      {title && <H3 sx={{ marginBottom: 'spacing-md' }}>{title}</H3>}
      <Grid
        templateColumns={[null, null, 'repeat(3, 1fr)']}
        rowGap="spacing-lg"
        columnGap="spacing-md"
      >
        {featuredLinks.map((featuredLink, index) => (
          <LinkBox
            key={`${featuredLink.imageUrl}-${featuredLink.title}-${featuredLink.url}`}
          >
            <LinkOverlay
              href={featuredLink.url}
              data-test-id="featured-links-grid"
              className={`sc-slot sc-slot-${index} ad-content-${
                featuredLink.url.split('/')[2]
              }`}
              onClick={() => trackers?.clicked?.(featuredLink.title)}
            >
              <CloudinaryImage
                ratio="3/2"
                imageSetOrImage={{
                  url: featuredLink.imageUrl ?? '',
                  type: imageType,
                  alt: `${featuredLink.title}`,
                }}
                sizes={IMAGE_SIZES_HERO_PORTRAIT}
                aria-labelledby={featuredLink.title}
                loadingMode="eager"
              />
              <Text
                as="p"
                isBodyText
                sx={{
                  marginTop: 'spacing-sm',
                  color: 'textSecondary',
                }}
              >
                {featuredLink.title}
              </Text>
            </LinkOverlay>
          </LinkBox>
        ))}
      </Grid>
    </>
  )
}
